// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"905":"8f7b34cc","3127":"de50ac5a","7904":"6a4610d4"}[chunkId] + ".chunk.css";
};